import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';
@Pipe({ name: 'PickupType' })
export class PickupTypePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(value: any): any {

    if (value !== undefined && value !== null && value !== '') {
      return this.loadPickupTypeText(value);
    }
  }

  loadPickupTypeText(type) {
     let classVal;
    switch (parseInt(type, 0)) {
      case PickupType.atmDeposit: {
        classVal = this.translate.instant('PickupTypeLabels_lblAtmDeposit');
        break;
      }
      case PickupType.bankDeposit: {
        classVal = this.translate.instant('PickupTypeLabels_lblBankDeposit');
        break;
      }
      case PickupType.homeDelivery: {
        classVal = this.translate.instant('PickupTypeLabels_lblHomeDelivery');
        break;
      }
      case PickupType.officePickup: {
        classVal = this.translate.instant('PickupTypeLabels_lblOfficePickup');
        break;
      }
    }
    return classVal;
  }

}
export enum PickupType {
  officePickup = 1,
  bankDeposit = 2,
  homeDelivery = 3,
  atmDeposit = 32
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/pickuptype.ts